import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export class Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};

export class Assignment {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  formResponse?: Maybe<Array<FormResponse>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export class AuthInput {
  code: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  redirectUri: Scalars['String'];
};

export class AuthType {
  token: Scalars['String'];
  user: User;
};

export class BenefitBreakdown {
  bomCount: Scalars['Int'];
  bomPct: Scalars['Float'];
  naCount: Scalars['Int'];
  otimoCount: Scalars['Int'];
  otimoPct: Scalars['Float'];
  regularCount: Scalars['Int'];
  regularPct: Scalars['Float'];
  ruimCount: Scalars['Int'];
  ruimPct: Scalars['Float'];
  totalAnswers: Scalars['Int'];
  totalJustifications: Scalars['Int'];
};

export class BenefitDashboardResult {
  general: Array<DashboardBenefitsYearValue>;
  questions: Array<BenefitQuestion>;
  satisfactionByUnity: Array<DashboardBenefitSatisfactionByUnity>;
};

export class BenefitOption {
  key: Scalars['String'];
  label: Scalars['String'];
};

export class BenefitOptionResult {
  items: Array<BenefitOption>;
};

export class BenefitQuestion {
  title: Scalars['String'];
  years: Array<BenefitQuestionYear>;
};

export class BenefitQuestionYear {
  breakdown: BenefitBreakdown;
  year: Scalars['Int'];
};

export class Country {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  flag?: Maybe<Scalars['String']>;
  form: Array<Form>;
  formResponse?: Maybe<Array<FormResponse>>;
  id: Scalars['ID'];
  language?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  unity?: Maybe<Array<Unity>>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<Array<User>>;
};

export class CountryPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results?: Maybe<Array<Country>>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class CreateCountryInput {
  flag?: InputMaybe<Scalars['String']>;
  /** Locale do i18n do Web: pt-BR | es-ES | en-US */
  language?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export class CreateFormGroupInput {
  name: Scalars['String'];
  order: Scalars['Float'];
  questions: Array<CreateFormQuestionInput>;
  tagId: Scalars['ID'];
};

export class CreateFormInput {
  countryId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  groups: Array<CreateFormGroupInput>;
  logoType?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  unityId: Scalars['ID'];
};

export class CreateFormQuestionInput {
  displayType?: InputMaybe<Scalars['String']>;
  hasNotApplicable: Scalars['Boolean'];
  isRequired: Scalars['Boolean'];
  options?: InputMaybe<Array<CreateFormQuestionOptionInput>>;
  order: Scalars['Float'];
  requireJustification?: Scalars['Boolean'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export class CreateFormQuestionOptionInput {
  order: Scalars['Float'];
  requireJustification?: Scalars['Boolean'];
  text?: InputMaybe<Scalars['String']>;
};

export class CreateUnityInput {
  countryId: Scalars['String'];
  name: Scalars['String'];
  status: Scalars['String'];
};

export class CreateUserInput {
  costCenter: Scalars['String'];
  countryId?: InputMaybe<Scalars['String']>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  email: Scalars['String'];
  gender: Scalars['String'];
  jobRoleId: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  photoUrl?: InputMaybe<Scalars['String']>;
  profile: Scalars['String'];
  re: Scalars['String'];
  status: Scalars['String'];
  unityId?: InputMaybe<Scalars['String']>;
  unityIds?: InputMaybe<Array<Scalars['String']>>;
};

export class DashboardBenefitRow {
  name: Scalars['String'];
  units: Array<DashboardBenefitUnitColumn>;
};

export class DashboardBenefitSatisfactionByUnity {
  units: Array<DashboardBenefitSatisfactionUnitValue>;
  year: Scalars['Int'];
};

export class DashboardBenefitSatisfactionUnitValue {
  percentage: Scalars['Float'];
  unity: Scalars['String'];
  unityId: Scalars['String'];
};

export class DashboardBenefitUnitColumn {
  unity: Scalars['String'];
  unityId: Scalars['String'];
  years: Array<DashboardBenefitYearValue>;
};

export class DashboardBenefitYearValue {
  notApplicable: Scalars['Boolean'];
  percentage?: Maybe<Scalars['Float']>;
  year: Scalars['Int'];
};

export class DashboardBenefitsYearValue {
  percentage: Scalars['Float'];
  year: Scalars['Int'];
};

export class DashboardGeneralResult {
  benefits: Array<DashboardBenefitRow>;
  general: Array<DashboardYearValue>;
  satisfactionByUnity: Array<DashboardSatisfactionByUnity>;
};

export class DashboardSatisfactionByUnity {
  units: Array<DashboardSatisfactionUnitValue>;
  year: Scalars['Int'];
};

export class DashboardSatisfactionUnitValue {
  percentage: Scalars['Float'];
  unity: Scalars['String'];
  unityId: Scalars['String'];
};

export class DashboardYearValue {
  percentage: Scalars['Float'];
  year: Scalars['Int'];
};

export class DefaultMessage {
  message: Scalars['String'];
  status: Scalars['Int'];
};

export class EnumType {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  detail?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};

export class Form {
  accessLink?: Maybe<Scalars['String']>;
  accessLogs: Array<FormAccessLog>;
  code?: Maybe<Scalars['String']>;
  country: Country;
  createdAt: Scalars['DateTime'];
  createdBy: User;
  dashboardLoadedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<User>;
  description?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['DateTime']>;
  formStatusLog: Array<FormStatusLog>;
  group: Array<FormGroup>;
  id: Scalars['ID'];
  logoType?: Maybe<Scalars['String']>;
  qrCode?: Maybe<Scalars['String']>;
  questions: Array<FormQuestion>;
  response: Array<FormResponse>;
  start?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  title: Scalars['String'];
  unity: Unity;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
};

export class FormAccessLog {
  accessedAt?: Maybe<Scalars['DateTime']>;
  browserLanguage?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deviceType?: Maybe<Scalars['String']>;
  form: Form;
  id: Scalars['ID'];
  ipAddress?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userAgent?: Maybe<Scalars['String']>;
};

export class FormDetailAssignmentCount {
  assignmentName: Scalars['String'];
  count: Scalars['Int'];
};

export class FormDetailDashboardResult {
  assignments: Array<FormDetailAssignmentCount>;
  daily: Array<FormDetailResponseDailyCount>;
  todayCount: Scalars['Int'];
};

export class FormDetailResponseDailyCount {
  count: Scalars['Int'];
  date: Scalars['DateTime'];
};

export class FormGroup {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  form: Form;
  id: Scalars['ID'];
  name: Scalars['String'];
  order: Scalars['Float'];
  questions: Array<FormQuestion>;
  tag?: Maybe<Tag>;
  updatedAt: Scalars['DateTime'];
};

export class FormGroupDto {
  name: Scalars['String'];
  questions: Array<FormQuestionDto>;
  tag?: Maybe<Scalars['String']>;
  tagId: Scalars['String'];
};

export class FormJustificationTextDto {
  justificationText: Scalars['String'];
};

export class FormListDashboardResult {
  assignments: Array<FormDetailAssignmentCount>;
  daily: Array<FormDetailResponseDailyCount>;
};

export class FormOptionDto {
  percentage: Scalars['Float'];
  text: Scalars['String'];
  totalAnswers: Scalars['Float'];
  valueClassification?: Maybe<Scalars['String']>;
};

export class FormOptionJustificationDto {
  justifications: Array<FormJustificationTextDto>;
  optionId: Scalars['String'];
  optionText: Scalars['String'];
  questionId: Scalars['String'];
  questionTitle: Scalars['String'];
  valueClassification?: Maybe<Scalars['String']>;
};

export class FormPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results?: Maybe<Array<SearchFormListDto>>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class FormQuestion {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  displayType?: Maybe<Scalars['String']>;
  form: Form;
  group: FormGroup;
  hasNotApplicable: Scalars['Boolean'];
  id: Scalars['ID'];
  isRequired: Scalars['Boolean'];
  options: Array<FormQuestionOptions>;
  order: Scalars['Float'];
  requireJustification: Scalars['Boolean'];
  response: Array<FormQuestionResponse>;
  title: Scalars['String'];
  type: FormQuestionType;
  updatedAt: Scalars['DateTime'];
};

export class FormQuestionDto {
  dashboardIcon?: Maybe<Array<YearlyRatingStats>>;
  dashboardNumber?: Maybe<Array<YearlyNumberStats>>;
  displayType: Scalars['String'];
  hasNotApplicable: Scalars['Boolean'];
  id: Scalars['String'];
  isRequired: Scalars['Boolean'];
  options: Array<FormOptionDto>;
  order: Scalars['Float'];
  requireJustification: Scalars['Boolean'];
  title: Scalars['String'];
  totalAnswers: Scalars['Float'];
  totalJustifications: Scalars['Float'];
  totalNotApplicable: Scalars['Float'];
  type: Scalars['String'];
};

export class FormQuestionOptions {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  formQuestionResponse: Array<FormQuestionResponse>;
  id: Scalars['ID'];
  order: Scalars['Float'];
  question: FormQuestion;
  requireJustification: Scalars['Boolean'];
  text?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  valueClassification?: Maybe<Scalars['Float']>;
};

export class FormQuestionResponse {
  answerText?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  fileUrl?: Maybe<Scalars['String']>;
  formResponse?: Maybe<FormResponse>;
  id: Scalars['ID'];
  isNotApplicable: Scalars['Boolean'];
  justificationText?: Maybe<Scalars['String']>;
  option?: Maybe<FormQuestionOptions>;
  question: FormQuestion;
  ratingValue?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
};

export class FormQuestionResponseItem {
  answerText?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  fileUrl?: Maybe<Scalars['String']>;
  option?: Maybe<QuestionOptionDto>;
  ratingValue?: Maybe<Scalars['Int']>;
};

export class FormQuestionType {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  label: Scalars['String'];
  questions: Array<FormQuestion>;
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export class FormResponse {
  answeredAt?: Maybe<Scalars['DateTime']>;
  assignment?: Maybe<Assignment>;
  country?: Maybe<Country>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  form: Form;
  formQuestionResponse?: Maybe<Array<FormQuestionResponse>>;
  id: Scalars['ID'];
  medicalAssistance?: Maybe<MedicalAssistance>;
  unity?: Maybe<Unity>;
  updatedAt: Scalars['DateTime'];
};

export class FormStatusLog {
  changedAt?: Maybe<Scalars['DateTime']>;
  changedBy: Scalars['String'];
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  form: Form;
  id: Scalars['ID'];
  newStatus: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
};

export class FormStructureDetailDto {
  accessLink: Scalars['String'];
  code: Scalars['String'];
  countryFlag?: Maybe<Scalars['String']>;
  countryName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdByName: Scalars['String'];
  daysToFinish: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  end: Scalars['DateTime'];
  groups: Array<FormGroupDto>;
  id: Scalars['String'];
  logoType?: Maybe<Scalars['String']>;
  qrCode: Scalars['String'];
  start: Scalars['DateTime'];
  status: Scalars['String'];
  title: Scalars['String'];
  totalAccesses: Scalars['Float'];
  totalResponses: Scalars['Float'];
  unityName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedByName?: Maybe<Scalars['String']>;
};

export class FormStructureFilterInput {
  end?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['DateTime']>;
  tagId?: InputMaybe<Scalars['String']>;
};

export class GroupedResponsesByQuestion {
  questionId: Scalars['ID'];
  questionTitle: Scalars['String'];
  responses: Array<FormQuestionResponseItem>;
};

export class GroupedResponsesByType {
  questions: Array<GroupedResponsesByQuestion>;
  total: Scalars['Float'];
  type: Scalars['String'];
};

export class JobRole {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: JobRole;
};

export class MedicalAssistance {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  formResponse?: Maybe<Array<FormResponse>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export class Mutation {
  /** Create new Country */
  createCountry: Country;
  /** Create Search Form */
  createForm: Form;
  /** Create new Unity */
  createUnity: Unity;
  /** Create new User */
  createUser: User;
  /** Delete Country by Id */
  deleteCountry: DefaultMessage;
  /** Delete Form by Id */
  deleteForm: DefaultMessage;
  /** Delete Unity by Id */
  deleteUnity: DefaultMessage;
  /** Delete User by Id */
  deleteUser: DefaultMessage;
  loadFormDashboard: DefaultMessage;
  login: AuthType;
  /** Send Response in Form */
  submitFormResponse: DefaultMessage;
  /** Update Country By Id */
  updateCountry: Country;
  /** Update Search Form */
  updateForm: Form;
  /** Update Status and Period Form By Id */
  updateStatusAndPeriod: Form;
  /** Update Unity By Id */
  updateUnity: Unity;
  /** Update User by Id */
  updateUser: User;
};


export class MutationCreateCountryArgs {
  data: CreateCountryInput;
};


export class MutationCreateFormArgs {
  data: CreateFormInput;
};


export class MutationCreateUnityArgs {
  data: CreateUnityInput;
};


export class MutationCreateUserArgs {
  data: CreateUserInput;
};


export class MutationDeleteCountryArgs {
  id: Scalars['String'];
};


export class MutationDeleteFormArgs {
  id: Scalars['String'];
};


export class MutationDeleteUnityArgs {
  id: Scalars['String'];
};


export class MutationDeleteUserArgs {
  id: Scalars['String'];
};


export class MutationLoadFormDashboardArgs {
  formId: Scalars['String'];
};


export class MutationLoginArgs {
  data: AuthInput;
};


export class MutationSubmitFormResponseArgs {
  data: SubmitFormResponseInput;
};


export class MutationUpdateCountryArgs {
  data: UpdateCountryInput;
};


export class MutationUpdateFormArgs {
  data: UpdateFormInput;
};


export class MutationUpdateStatusAndPeriodArgs {
  data: UpdateStatusAndPeriodInput;
};


export class MutationUpdateUnityArgs {
  data: UpdateUnityInput;
};


export class MutationUpdateUserArgs {
  data: UpdateUserInput;
};

export class Query {
  /** List All Medical Assistance */
  allMedicalAssistance: Array<MedicalAssistance>;
  /** Return Assignment By ID */
  assignmentById: Assignment;
  /** List All Assignment */
  assignments: Array<Assignment>;
  canEditForm: Scalars['Boolean'];
  /** Return Country by Id */
  countryById: Country;
  /** Return User Logged */
  currentUser: User;
  /** Return All By Type */
  enumByType: Array<EnumType>;
  /** Return Enum Type by Id */
  enumTypeById: EnumType;
  /** Return All Enum Types */
  enumTypes: Array<EnumType>;
  /** Return Form by Code */
  formByCode: Form;
  /** Return Form by Id */
  formById: Form;
  formDetailDashboard: FormDetailDashboardResult;
  formListDashboard: FormListDashboardResult;
  getDashboardBenefit: BenefitDashboardResult;
  getDashboardGeneral: DashboardGeneralResult;
  /** Return all forms response structure */
  getFormStructureDetail: FormStructureDetailDto;
  /** Return all justifications by question ID */
  getJustificationsByQuestionId: Array<FormOptionJustificationDto>;
  /** Return JobRole By ID */
  jobRoleById: JobRole;
  /** List All Job Roles */
  jobRoles: Array<JobRole>;
  listBenefitOptions: BenefitOptionResult;
  /** List All Country */
  listCountry: Array<Country>;
  /** List All Unity */
  listUnity: Array<Unity>;
  /** Return Medical Assistance By ID */
  medicalAssistanceById: MedicalAssistance;
  /** Return all countries paged */
  searchAllCountry: CountryPage;
  /** Return all unities paged */
  searchAllUnity: UnityPage;
  /** Return All users paged */
  searchAllUser: UserPage;
  /** Return all forms paged */
  searchForms: FormPage;
  /** Return Tag By ID */
  tagById: Tag;
  /** List All Tags */
  tags: Array<Tag>;
  /** Return Unity by Country Id */
  unityByCountryId: Array<Unity>;
  /** Return Unities by Country Ids */
  unityByCountryIds: Array<Unity>;
  /** Return Unity by Id */
  unityById: Unity;
  /** Return User By Id */
  userById: User;
  /** Valid form question with code */
  validFormQuestion: Form;
};


export class QueryAssignmentByIdArgs {
  id: Scalars['String'];
};


export class QueryCanEditFormArgs {
  formId: Scalars['String'];
};


export class QueryCountryByIdArgs {
  id: Scalars['String'];
};


export class QueryEnumByTypeArgs {
  type: Scalars['String'];
};


export class QueryEnumTypeByIdArgs {
  id: Scalars['String'];
};


export class QueryFormByCodeArgs {
  code: Scalars['String'];
};


export class QueryFormByIdArgs {
  id: Scalars['String'];
};


export class QueryFormDetailDashboardArgs {
  data: SearchDetailDashboardInput;
};


export class QueryFormListDashboardArgs {
  data: SearchListFormDashboardInput;
};


export class QueryGetDashboardBenefitArgs {
  data: SearchDashboardBenefitInput;
};


export class QueryGetDashboardGeneralArgs {
  data: SearchDashboardGeneralInput;
};


export class QueryGetFormStructureDetailArgs {
  data?: InputMaybe<FormStructureFilterInput>;
  formId: Scalars['String'];
};


export class QueryGetJustificationsByQuestionIdArgs {
  questionId: Scalars['String'];
};


export class QueryJobRoleByIdArgs {
  id: Scalars['String'];
};


export class QueryListBenefitOptionsArgs {
  data: SearchBenefitOptionsInput;
};


export class QueryMedicalAssistanceByIdArgs {
  id: Scalars['String'];
};


export class QuerySearchAllCountryArgs {
  data: SearchCountryInput;
};


export class QuerySearchAllUnityArgs {
  data: SearchUnityInput;
};


export class QuerySearchAllUserArgs {
  data: SearchUserInput;
};


export class QuerySearchFormsArgs {
  data: SearchFormInput;
};


export class QueryTagByIdArgs {
  id: Scalars['String'];
};


export class QueryUnityByCountryIdArgs {
  countryId: Scalars['String'];
};


export class QueryUnityByCountryIdsArgs {
  countryIds: Array<Scalars['String']>;
};


export class QueryUnityByIdArgs {
  id: Scalars['String'];
};


export class QueryUserByIdArgs {
  id: Scalars['String'];
};


export class QueryValidFormQuestionArgs {
  code: Scalars['String'];
};

export class QuestionOptionDto {
  id: Scalars['ID'];
  text: Scalars['String'];
};

export class RatingDistribution {
  percentage: Scalars['Float'];
  value: Scalars['Int'];
};

export class SearchBenefitOptionsInput {
  unityIds: Array<Scalars['String']>;
};

export class SearchCountryInput {
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export class SearchDashboardBenefitInput {
  /** Nome do benef�cio (groupName) */
  groupName: Scalars['String'];
  unityIds?: InputMaybe<Array<Scalars['String']>>;
};

export class SearchDashboardGeneralInput {
  unityIds: Array<Scalars['String']>;
};

export class SearchDetailDashboardInput {
  end?: InputMaybe<Scalars['DateTime']>;
  formId: Scalars['String'];
  start?: InputMaybe<Scalars['DateTime']>;
};

export class SearchFormInput {
  countryId?: InputMaybe<Array<Scalars['String']>>;
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  unityId?: InputMaybe<Array<Scalars['String']>>;
};

export class SearchFormListDto {
  accessLink: Scalars['String'];
  code: Scalars['String'];
  countryName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdByName: Scalars['String'];
  dashboardLoadedAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  end: Scalars['DateTime'];
  id: Scalars['ID'];
  qrCode: Scalars['String'];
  start: Scalars['DateTime'];
  status: Scalars['String'];
  title: Scalars['String'];
  unityName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedByName?: Maybe<Scalars['String']>;
};

export class SearchListFormDashboardInput {
  countryId?: InputMaybe<Array<Scalars['String']>>;
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  unityId?: InputMaybe<Array<Scalars['String']>>;
};

export class SearchUnityInput {
  countryId?: InputMaybe<Array<Scalars['String']>>;
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Array<Scalars['String']>>;
};

export class SearchUserInput {
  countryId?: InputMaybe<Array<Scalars['String']>>;
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  profile?: InputMaybe<Array<Scalars['String']>>;
  start?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  unityId?: InputMaybe<Array<Scalars['String']>>;
};

export class SubmitFormQuestionResponseInput {
  answerText?: InputMaybe<Scalars['String']>;
  fileUrl?: InputMaybe<Scalars['String']>;
  isNotApplicable?: InputMaybe<Scalars['Boolean']>;
  justificationText?: InputMaybe<Scalars['String']>;
  optionIds?: InputMaybe<Array<Scalars['ID']>>;
  questionId: Scalars['ID'];
};

export class SubmitFormResponseInput {
  answers: Array<SubmitFormQuestionResponseInput>;
  assignmentId: Scalars['ID'];
  countryId: Scalars['ID'];
  formId: Scalars['ID'];
  medicalAssistanceId?: InputMaybe<Scalars['ID']>;
  unityId: Scalars['ID'];
};

export class Tag {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  group?: Maybe<Array<FormGroup>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export class Unity {
  country?: Maybe<Country>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  form: Array<Form>;
  formResponse?: Maybe<Array<FormResponse>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<Array<User>>;
};

export class UnityPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results?: Maybe<Array<Unity>>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class UpdateCountryInput {
  flag?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  /** Locale do i18n do Web: pt-BR | es-ES | en-US */
  language?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export class UpdateFormGroupInput {
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order: Scalars['Float'];
  questions: Array<UpdateFormQuestionInput>;
  tagId: Scalars['ID'];
};

export class UpdateFormInput {
  countryId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  groups: Array<UpdateFormGroupInput>;
  id: Scalars['ID'];
  logoType?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  unityId: Scalars['ID'];
};

export class UpdateFormQuestionInput {
  displayType?: InputMaybe<Scalars['String']>;
  hasNotApplicable: Scalars['Boolean'];
  id?: InputMaybe<Scalars['String']>;
  isRequired: Scalars['Boolean'];
  options?: InputMaybe<Array<UpdateFormQuestionOptionInput>>;
  order: Scalars['Float'];
  requireJustification?: Scalars['Boolean'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export class UpdateFormQuestionOptionInput {
  id?: InputMaybe<Scalars['String']>;
  order: Scalars['Float'];
  requireJustification?: Scalars['Boolean'];
  text: Scalars['String'];
};

export class UpdateStatusAndPeriodInput {
  end?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  start?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
};

export class UpdateUnityInput {
  countryId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export class UpdateUserInput {
  costCenter?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['String']>;
  countryIds?: InputMaybe<Array<Scalars['String']>>;
  email?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  jobRoleId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<Scalars['String']>;
  re?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unityId?: InputMaybe<Scalars['String']>;
  unityIds?: InputMaybe<Array<Scalars['String']>>;
};

export class User {
  costCenter?: Maybe<Scalars['String']>;
  countries?: Maybe<Array<Country>>;
  country?: Maybe<Country>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  form: Array<Form>;
  formDeleted?: Maybe<Array<Form>>;
  formStatusLog?: Maybe<Array<FormStatusLog>>;
  formUpdated?: Maybe<Array<Form>>;
  gender: Scalars['String'];
  id: Scalars['ID'];
  jobRole?: Maybe<JobRole>;
  name: Scalars['String'];
  phone: Scalars['String'];
  photoUrl?: Maybe<Scalars['String']>;
  profile: Scalars['String'];
  re: Scalars['String'];
  status: Scalars['String'];
  unities?: Maybe<Array<Unity>>;
  unity?: Maybe<Unity>;
  updatedAt: Scalars['DateTime'];
};

export class UserPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results?: Maybe<Array<User>>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class YearlyNumberStats {
  distribution: Array<FormOptionDto>;
  year: Scalars['Int'];
};

export class YearlyRatingStats {
  average?: Maybe<Scalars['Float']>;
  distribution: Array<RatingDistribution>;
  year: Scalars['Int'];
};

export type AuthTypeFragment = { token: string, user: { id: string, name: string, email: string, re: string, phone: string, gender: string, profile: string, status: string, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, countries?: Array<{ id: string, name: string }> | null, unities?: Array<{ id: string, name: string, country?: { id: string } | null }> | null, jobRole?: { id: string, name: string } | null } };

export type EnumTypeFragment = { description?: string | null, detail?: string | null, id: string, type: string, value: string };

export type UserFragment = { id: string, name: string, email: string, re: string, phone: string, gender: string, profile: string, status: string, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, countries?: Array<{ id: string, name: string }> | null, unities?: Array<{ id: string, name: string, country?: { id: string } | null }> | null, jobRole?: { id: string, name: string } | null };

export type DefaultMessageFragment = { message: string, status: number };

export type UnityPageFragment = { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results?: Array<{ id: string, name: string, status?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: Array<{ id: string, name: string }> | null }> | null };

export type UnityFragment = { id: string, name: string, status?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: string, profile: string, status: string, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, countries?: Array<{ id: string, name: string }> | null, unities?: Array<{ id: string, name: string, country?: { id: string } | null }> | null, jobRole?: { id: string, name: string } | null }> | null, country?: { createdAt: any, deletedAt?: any | null, flag?: string | null, language?: string | null, id: string, name: string, updatedAt: any } | null };

export type CountryFragment = { createdAt: any, deletedAt?: any | null, flag?: string | null, language?: string | null, id: string, name: string, updatedAt: any };

export type FormFragment = { accessLink?: string | null, code?: string | null, logoType?: string | null, createdAt: any, deletedAt?: any | null, description?: string | null, end?: any | null, id: string, qrCode?: string | null, start?: any | null, status: string, title: string, updatedAt: any };

export type FormWebFragment = { accessLink?: string | null, logoType?: string | null, code?: string | null, createdAt: any, deletedAt?: any | null, description?: string | null, end?: any | null, id: string, qrCode?: string | null, start?: any | null, status: string, title: string, updatedAt: any, country: { createdAt: any, deletedAt?: any | null, flag?: string | null, language?: string | null, id: string, name: string, updatedAt: any }, group: Array<{ createdAt: any, deletedAt?: any | null, updatedAt: any, id: string, name: string, order: number, tag?: { id: string, name: string } | null, questions: Array<{ createdAt: any, deletedAt?: any | null, displayType?: string | null, hasNotApplicable: boolean, id: string, isRequired: boolean, order: number, requireJustification: boolean, title: string, updatedAt: any, options: Array<{ createdAt: any, deletedAt?: any | null, id: string, order: number, requireJustification: boolean, text?: string | null, updatedAt: any, valueClassification?: number | null }>, type: { createdAt: any, deletedAt?: any | null, id: string, isActive: boolean, label: string, type: string, updatedAt: any } }> }>, unity: { id: string, name: string, country?: { flag?: string | null } | null } };

export type SearchFormListDtoFragment = { accessLink: string, code: string, countryName: string, createdAt: any, createdByName: string, dashboardLoadedAt?: any | null, description: string, end: any, id: string, qrCode: string, start: any, status: string, title: string, unityName: string, updatedAt: any };

export type FormStructureDetailDtoFragment = { id: string, title: string, description?: string | null, status: string, code: string, qrCode: string, accessLink: string, createdByName: string, updatedByName?: string | null, countryName: string, countryFlag?: string | null, unityName: string, start: any, end: any, createdAt: any, updatedAt: any, totalAccesses: number, totalResponses: number, daysToFinish: number, groups: Array<{ name: string, tag?: string | null, tagId: string, questions: Array<{ id: string, order: number, title: string, type: string, displayType: string, isRequired: boolean, hasNotApplicable: boolean, requireJustification: boolean, totalAnswers: number, totalNotApplicable: number, totalJustifications: number, options: Array<{ text: string, totalAnswers: number, percentage: number, valueClassification?: string | null }>, dashboardIcon?: Array<{ year: number, average?: number | null, distribution: Array<{ value: number, percentage: number }> }> | null, dashboardNumber?: Array<{ year: number, distribution: Array<{ text: string, totalAnswers: number, percentage: number, valueClassification?: string | null }> }> | null }> }> };

export type JobRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type JobRolesQuery = { jobRoles: Array<{ id: string, name: string }> };

export type AssignmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type AssignmentsQuery = { assignments: Array<{ id: string, name: string }> };

export type TagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TagsQuery = { tags: Array<{ id: string, name: string }> };

export type ListUnityQueryVariables = Exact<{ [key: string]: never; }>;


export type ListUnityQuery = { listUnity: Array<{ id: string, name: string }> };

export type EnumByTypeQueryVariables = Exact<{
  type: Scalars['String'];
}>;


export type EnumByTypeQuery = { enumByType: Array<{ description?: string | null, detail?: string | null, id: string, type: string, value: string }> };

export type EnumTypeByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type EnumTypeByIdQuery = { enumTypeById: { description?: string | null, detail?: string | null, id: string, type: string, value: string } };

export type EnumTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type EnumTypesQuery = { enumTypes: Array<{ description?: string | null, detail?: string | null, id: string, type: string, value: string }> };

export type SearchAllCountryQueryVariables = Exact<{
  input: SearchCountryInput;
}>;


export type SearchAllCountryQuery = { searchAllCountry: { currentPage: number, nextPage: boolean, pageSize: number, previousPage: boolean, totalCount: number, totalPage: number, results?: Array<{ createdAt: any, deletedAt?: any | null, flag?: string | null, language?: string | null, id: string, name: string, updatedAt: any }> | null } };

export type ListCountryQueryVariables = Exact<{ [key: string]: never; }>;


export type ListCountryQuery = { listCountry: Array<{ createdAt: any, deletedAt?: any | null, flag?: string | null, language?: string | null, id: string, name: string, updatedAt: any }> };

export type CreateCountryMutationVariables = Exact<{
  input: CreateCountryInput;
}>;


export type CreateCountryMutation = { createCountry: { createdAt: any, deletedAt?: any | null, flag?: string | null, language?: string | null, id: string, name: string, updatedAt: any } };

export type UpdateCountryMutationVariables = Exact<{
  input: UpdateCountryInput;
}>;


export type UpdateCountryMutation = { updateCountry: { createdAt: any, deletedAt?: any | null, flag?: string | null, language?: string | null, id: string, name: string, updatedAt: any } };

export type DeleteCountryMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCountryMutation = { deleteCountry: { message: string, status: number } };

export type GetDashboardGeneralQueryVariables = Exact<{
  data: SearchDashboardGeneralInput;
}>;


export type GetDashboardGeneralQuery = { getDashboardGeneral: { general: Array<{ percentage: number, year: number }>, satisfactionByUnity: Array<{ year: number, units: Array<{ percentage: number, unity: string, unityId: string }> }>, benefits: Array<{ name: string, units: Array<{ unityId: string, unity: string, years: Array<{ percentage?: number | null, year: number, notApplicable: boolean }> }> }> } };

export type ListBenefitOptionsQueryVariables = Exact<{
  data: SearchBenefitOptionsInput;
}>;


export type ListBenefitOptionsQuery = { listBenefitOptions: { items: Array<{ label: string, key: string }> } };

export type GetDashboardBenefitQueryVariables = Exact<{
  data: SearchDashboardBenefitInput;
}>;


export type GetDashboardBenefitQuery = { getDashboardBenefit: { general: Array<{ year: number, percentage: number }>, satisfactionByUnity: Array<{ year: number, units: Array<{ percentage: number, unity: string, unityId: string }> }>, questions: Array<{ title: string, years: Array<{ year: number, breakdown: { bomCount: number, bomPct: number, naCount: number, otimoCount: number, otimoPct: number, regularCount: number, regularPct: number, ruimCount: number, ruimPct: number, totalAnswers: number, totalJustifications: number } }> }> } };

export type ValidFormQuestionQueryVariables = Exact<{
  input: Scalars['String'];
}>;


export type ValidFormQuestionQuery = { validFormQuestion: { accessLink?: string | null, logoType?: string | null, code?: string | null, createdAt: any, deletedAt?: any | null, description?: string | null, end?: any | null, id: string, qrCode?: string | null, start?: any | null, status: string, title: string, updatedAt: any, country: { createdAt: any, deletedAt?: any | null, flag?: string | null, language?: string | null, id: string, name: string, updatedAt: any }, group: Array<{ createdAt: any, deletedAt?: any | null, updatedAt: any, id: string, name: string, order: number, tag?: { id: string, name: string } | null, questions: Array<{ createdAt: any, deletedAt?: any | null, displayType?: string | null, hasNotApplicable: boolean, id: string, isRequired: boolean, order: number, requireJustification: boolean, title: string, updatedAt: any, options: Array<{ createdAt: any, deletedAt?: any | null, id: string, order: number, requireJustification: boolean, text?: string | null, updatedAt: any, valueClassification?: number | null }>, type: { createdAt: any, deletedAt?: any | null, id: string, isActive: boolean, label: string, type: string, updatedAt: any } }> }>, unity: { id: string, name: string, country?: { flag?: string | null } | null } } };

export type FormListDashboardQueryVariables = Exact<{
  input: SearchListFormDashboardInput;
}>;


export type FormListDashboardQuery = { formListDashboard: { assignments: Array<{ assignmentName: string, count: number }>, daily: Array<{ count: number, date: any }> } };

export type CanEditFormQueryVariables = Exact<{
  input: Scalars['String'];
}>;


export type CanEditFormQuery = { canEditForm: boolean };

export type FormByIdQueryVariables = Exact<{
  input: Scalars['String'];
}>;


export type FormByIdQuery = { formById: { accessLink?: string | null, logoType?: string | null, code?: string | null, createdAt: any, deletedAt?: any | null, description?: string | null, end?: any | null, id: string, qrCode?: string | null, start?: any | null, status: string, title: string, updatedAt: any, country: { createdAt: any, deletedAt?: any | null, flag?: string | null, language?: string | null, id: string, name: string, updatedAt: any }, group: Array<{ createdAt: any, deletedAt?: any | null, updatedAt: any, id: string, name: string, order: number, tag?: { id: string, name: string } | null, questions: Array<{ createdAt: any, deletedAt?: any | null, displayType?: string | null, hasNotApplicable: boolean, id: string, isRequired: boolean, order: number, requireJustification: boolean, title: string, updatedAt: any, options: Array<{ createdAt: any, deletedAt?: any | null, id: string, order: number, requireJustification: boolean, text?: string | null, updatedAt: any, valueClassification?: number | null }>, type: { createdAt: any, deletedAt?: any | null, id: string, isActive: boolean, label: string, type: string, updatedAt: any } }> }>, unity: { id: string, name: string, country?: { flag?: string | null } | null } } };

export type AllMedicalAssistanceQueryVariables = Exact<{ [key: string]: never; }>;


export type AllMedicalAssistanceQuery = { allMedicalAssistance: Array<{ id: string, name: string }> };

export type SubmitFormResponseMutationVariables = Exact<{
  input: SubmitFormResponseInput;
}>;


export type SubmitFormResponseMutation = { submitFormResponse: { message: string, status: number } };

export type SearchFormsQueryVariables = Exact<{
  input: SearchFormInput;
}>;


export type SearchFormsQuery = { searchForms: { currentPage: number, nextPage: boolean, pageSize: number, previousPage: boolean, totalCount: number, totalPage: number, results?: Array<{ accessLink: string, code: string, countryName: string, createdAt: any, createdByName: string, dashboardLoadedAt?: any | null, description: string, end: any, id: string, qrCode: string, start: any, status: string, title: string, unityName: string, updatedAt: any }> | null } };

export type GetFormStructureDetailQueryVariables = Exact<{
  id: Scalars['String'];
  input: FormStructureFilterInput;
}>;


export type GetFormStructureDetailQuery = { getFormStructureDetail: { id: string, title: string, description?: string | null, status: string, code: string, qrCode: string, accessLink: string, createdByName: string, updatedByName?: string | null, countryName: string, countryFlag?: string | null, unityName: string, start: any, end: any, createdAt: any, updatedAt: any, totalAccesses: number, totalResponses: number, daysToFinish: number, groups: Array<{ name: string, tag?: string | null, tagId: string, questions: Array<{ id: string, order: number, title: string, type: string, displayType: string, isRequired: boolean, hasNotApplicable: boolean, requireJustification: boolean, totalAnswers: number, totalNotApplicable: number, totalJustifications: number, options: Array<{ text: string, totalAnswers: number, percentage: number, valueClassification?: string | null }>, dashboardIcon?: Array<{ year: number, average?: number | null, distribution: Array<{ value: number, percentage: number }> }> | null, dashboardNumber?: Array<{ year: number, distribution: Array<{ text: string, totalAnswers: number, percentage: number, valueClassification?: string | null }> }> | null }> }> } };

export type GetJustificationsByQuestionIdQueryVariables = Exact<{
  questionId: Scalars['String'];
}>;


export type GetJustificationsByQuestionIdQuery = { getJustificationsByQuestionId: Array<{ questionId: string, questionTitle: string, optionId: string, valueClassification?: string | null, optionText: string, justifications: Array<{ justificationText: string }> }> };

export type FormDetailDashboardQueryVariables = Exact<{
  data: SearchDetailDashboardInput;
}>;


export type FormDetailDashboardQuery = { formDetailDashboard: { todayCount: number, assignments: Array<{ assignmentName: string, count: number }>, daily: Array<{ count: number, date: any }> } };

export type CreateFormMutationVariables = Exact<{
  input: CreateFormInput;
}>;


export type CreateFormMutation = { createForm: { accessLink?: string | null, code?: string | null, logoType?: string | null, createdAt: any, deletedAt?: any | null, description?: string | null, end?: any | null, id: string, qrCode?: string | null, start?: any | null, status: string, title: string, updatedAt: any } };

export type UpdateFormMutationVariables = Exact<{
  input: UpdateFormInput;
}>;


export type UpdateFormMutation = { updateForm: { accessLink?: string | null, code?: string | null, logoType?: string | null, createdAt: any, deletedAt?: any | null, description?: string | null, end?: any | null, id: string, qrCode?: string | null, start?: any | null, status: string, title: string, updatedAt: any } };

export type DeleteFormMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteFormMutation = { deleteForm: { message: string, status: number } };

export type LoadFormDashboardMutationVariables = Exact<{
  formId: Scalars['String'];
}>;


export type LoadFormDashboardMutation = { loadFormDashboard: { message: string, status: number } };

export type UpdateStatusAndPeriodMutationVariables = Exact<{
  data: UpdateStatusAndPeriodInput;
}>;


export type UpdateStatusAndPeriodMutation = { updateStatusAndPeriod: { accessLink?: string | null, logoType?: string | null, code?: string | null, createdAt: any, deletedAt?: any | null, description?: string | null, end?: any | null, id: string, qrCode?: string | null, start?: any | null, status: string, title: string, updatedAt: any, country: { createdAt: any, deletedAt?: any | null, flag?: string | null, language?: string | null, id: string, name: string, updatedAt: any }, group: Array<{ createdAt: any, deletedAt?: any | null, updatedAt: any, id: string, name: string, order: number, tag?: { id: string, name: string } | null, questions: Array<{ createdAt: any, deletedAt?: any | null, displayType?: string | null, hasNotApplicable: boolean, id: string, isRequired: boolean, order: number, requireJustification: boolean, title: string, updatedAt: any, options: Array<{ createdAt: any, deletedAt?: any | null, id: string, order: number, requireJustification: boolean, text?: string | null, updatedAt: any, valueClassification?: number | null }>, type: { createdAt: any, deletedAt?: any | null, id: string, isActive: boolean, label: string, type: string, updatedAt: any } }> }>, unity: { id: string, name: string, country?: { flag?: string | null } | null } } };

export type SearchAllUnityQueryVariables = Exact<{
  input: SearchUnityInput;
}>;


export type SearchAllUnityQuery = { searchAllUnity: { currentPage: number, nextPage: boolean, pageSize: number, previousPage: boolean, totalCount: number, totalPage: number, results?: Array<{ id: string, name: string, status?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: string, profile: string, status: string, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, countries?: Array<{ id: string, name: string }> | null, unities?: Array<{ id: string, name: string, country?: { id: string } | null }> | null, jobRole?: { id: string, name: string } | null }> | null, country?: { createdAt: any, deletedAt?: any | null, flag?: string | null, language?: string | null, id: string, name: string, updatedAt: any } | null }> | null } };

export type UnityByCountryIdQueryVariables = Exact<{
  countryId: Scalars['String'];
}>;


export type UnityByCountryIdQuery = { unityByCountryId: Array<{ id: string, name: string, status?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: string, profile: string, status: string, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, countries?: Array<{ id: string, name: string }> | null, unities?: Array<{ id: string, name: string, country?: { id: string } | null }> | null, jobRole?: { id: string, name: string } | null }> | null, country?: { createdAt: any, deletedAt?: any | null, flag?: string | null, language?: string | null, id: string, name: string, updatedAt: any } | null }> };

export type UnityByCountryIdsQueryVariables = Exact<{
  countryIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type UnityByCountryIdsQuery = { unityByCountryIds: Array<{ id: string, name: string, status?: string | null, country?: { id: string, name: string } | null }> };

export type CreateUnityMutationVariables = Exact<{
  input: CreateUnityInput;
}>;


export type CreateUnityMutation = { createUnity: { id: string, name: string, status?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: string, profile: string, status: string, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, countries?: Array<{ id: string, name: string }> | null, unities?: Array<{ id: string, name: string, country?: { id: string } | null }> | null, jobRole?: { id: string, name: string } | null }> | null, country?: { createdAt: any, deletedAt?: any | null, flag?: string | null, language?: string | null, id: string, name: string, updatedAt: any } | null } };

export type UpdateUnityMutationVariables = Exact<{
  input: UpdateUnityInput;
}>;


export type UpdateUnityMutation = { updateUnity: { id: string, name: string, status?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, user?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: string, profile: string, status: string, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, countries?: Array<{ id: string, name: string }> | null, unities?: Array<{ id: string, name: string, country?: { id: string } | null }> | null, jobRole?: { id: string, name: string } | null }> | null, country?: { createdAt: any, deletedAt?: any | null, flag?: string | null, language?: string | null, id: string, name: string, updatedAt: any } | null } };

export type DeleteUnityMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteUnityMutation = { deleteUnity: { message: string, status: number } };

export type LoginMutationVariables = Exact<{
  data: AuthInput;
}>;


export type LoginMutation = { login: { token: string, user: { id: string, name: string, email: string, re: string, phone: string, gender: string, profile: string, status: string, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, countries?: Array<{ id: string, name: string }> | null, unities?: Array<{ id: string, name: string, country?: { id: string } | null }> | null, jobRole?: { id: string, name: string } | null } } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { currentUser: { id: string, name: string, email: string, re: string, phone: string, gender: string, profile: string, status: string, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, countries?: Array<{ id: string, name: string }> | null, unities?: Array<{ id: string, name: string, country?: { id: string } | null }> | null, jobRole?: { id: string, name: string } | null } };

export type SearchAllUserQueryVariables = Exact<{
  data: SearchUserInput;
}>;


export type SearchAllUserQuery = { searchAllUser: { currentPage: number, nextPage: boolean, pageSize: number, previousPage: boolean, totalCount: number, totalPage: number, results?: Array<{ id: string, name: string, email: string, re: string, phone: string, gender: string, profile: string, status: string, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, countries?: Array<{ id: string, name: string }> | null, unities?: Array<{ id: string, name: string, country?: { id: string } | null }> | null, jobRole?: { id: string, name: string } | null }> | null } };

export type CreateUserMutationVariables = Exact<{
  data: CreateUserInput;
}>;


export type CreateUserMutation = { createUser: { id: string, name: string, email: string, re: string, phone: string, gender: string, profile: string, status: string, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, countries?: Array<{ id: string, name: string }> | null, unities?: Array<{ id: string, name: string, country?: { id: string } | null }> | null, jobRole?: { id: string, name: string } | null } };

export type UpdateUserMutationVariables = Exact<{
  data: UpdateUserInput;
}>;


export type UpdateUserMutation = { updateUser: { id: string, name: string, email: string, re: string, phone: string, gender: string, profile: string, status: string, costCenter?: string | null, photoUrl?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string } | null, unity?: { id: string, name: string } | null, countries?: Array<{ id: string, name: string }> | null, unities?: Array<{ id: string, name: string, country?: { id: string } | null }> | null, jobRole?: { id: string, name: string } | null } };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteUserMutation = { deleteUser: { message: string, status: number } };

export const UserFragmentDoc = gql`
    fragment User on User {
  id
  name
  email
  re
  phone
  gender
  profile
  status
  costCenter
  photoUrl
  createdAt
  updatedAt
  deletedAt
  status
  country {
    id
    name
  }
  unity {
    id
    name
  }
  countries {
    id
    name
  }
  unities {
    id
    name
    country {
      id
    }
  }
  jobRole {
    id
    name
  }
}
    `;
export const AuthTypeFragmentDoc = gql`
    fragment AuthType on AuthType {
  token
  user {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const EnumTypeFragmentDoc = gql`
    fragment EnumType on EnumType {
  description
  detail
  id
  type
  value
}
    `;
export const DefaultMessageFragmentDoc = gql`
    fragment DefaultMessage on DefaultMessage {
  message
  status
}
    `;
export const UnityPageFragmentDoc = gql`
    fragment UnityPage on UnityPage {
  totalCount
  pageSize
  currentPage
  totalPage
  previousPage
  nextPage
  results {
    id
    name
    status
    createdAt
    updatedAt
    deletedAt
    user {
      id
      name
    }
  }
}
    `;
export const CountryFragmentDoc = gql`
    fragment Country on Country {
  createdAt
  deletedAt
  flag
  language
  id
  name
  updatedAt
}
    `;
export const UnityFragmentDoc = gql`
    fragment Unity on Unity {
  id
  name
  status
  createdAt
  updatedAt
  deletedAt
  user {
    ...User
  }
  country {
    ...Country
  }
}
    ${UserFragmentDoc}
${CountryFragmentDoc}`;
export const FormFragmentDoc = gql`
    fragment Form on Form {
  accessLink
  code
  logoType
  createdAt
  deletedAt
  description
  end
  id
  qrCode
  start
  status
  title
  updatedAt
}
    `;
export const FormWebFragmentDoc = gql`
    fragment FormWeb on Form {
  accessLink
  logoType
  code
  country {
    ...Country
  }
  createdAt
  deletedAt
  description
  end
  group {
    createdAt
    deletedAt
    updatedAt
    id
    name
    tag {
      id
      name
    }
    order
    questions {
      createdAt
      deletedAt
      displayType
      hasNotApplicable
      id
      isRequired
      options {
        createdAt
        deletedAt
        id
        order
        requireJustification
        text
        updatedAt
        valueClassification
      }
      order
      requireJustification
      title
      type {
        createdAt
        deletedAt
        id
        isActive
        label
        type
        updatedAt
      }
      updatedAt
    }
  }
  id
  qrCode
  start
  status
  title
  unity {
    id
    country {
      flag
    }
    name
  }
  updatedAt
}
    ${CountryFragmentDoc}`;
export const SearchFormListDtoFragmentDoc = gql`
    fragment SearchFormListDto on SearchFormListDto {
  accessLink
  code
  countryName
  createdAt
  createdByName
  dashboardLoadedAt
  description
  end
  id
  qrCode
  start
  status
  title
  unityName
  updatedAt
}
    `;
export const FormStructureDetailDtoFragmentDoc = gql`
    fragment FormStructureDetailDto on FormStructureDetailDto {
  id
  title
  description
  status
  code
  qrCode
  accessLink
  createdByName
  updatedByName
  countryName
  countryFlag
  unityName
  start
  end
  createdAt
  updatedAt
  totalAccesses
  totalResponses
  daysToFinish
  groups {
    name
    tag
    tagId
    questions {
      id
      order
      title
      type
      displayType
      isRequired
      hasNotApplicable
      requireJustification
      totalAnswers
      totalNotApplicable
      totalJustifications
      options {
        text
        totalAnswers
        percentage
        valueClassification
      }
      dashboardIcon {
        year
        average
        distribution {
          value
          percentage
        }
      }
      dashboardNumber {
        year
        distribution {
          text
          totalAnswers
          percentage
          valueClassification
        }
      }
    }
  }
}
    `;
export const JobRolesDocument = gql`
    query jobRoles {
  jobRoles {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class JobRolesGQL extends Apollo.Query<JobRolesQuery, JobRolesQueryVariables> {
    document = JobRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssignmentsDocument = gql`
    query assignments {
  assignments {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignmentsGQL extends Apollo.Query<AssignmentsQuery, AssignmentsQueryVariables> {
    document = AssignmentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TagsDocument = gql`
    query tags {
  tags {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TagsGQL extends Apollo.Query<TagsQuery, TagsQueryVariables> {
    document = TagsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListUnityDocument = gql`
    query listUnity {
  listUnity {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListUnityGQL extends Apollo.Query<ListUnityQuery, ListUnityQueryVariables> {
    document = ListUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnumByTypeDocument = gql`
    query enumByType($type: String!) {
  enumByType(type: $type) {
    ...EnumType
  }
}
    ${EnumTypeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EnumByTypeGQL extends Apollo.Query<EnumByTypeQuery, EnumByTypeQueryVariables> {
    document = EnumByTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnumTypeByIdDocument = gql`
    query enumTypeById($id: String!) {
  enumTypeById(id: $id) {
    ...EnumType
  }
}
    ${EnumTypeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EnumTypeByIdGQL extends Apollo.Query<EnumTypeByIdQuery, EnumTypeByIdQueryVariables> {
    document = EnumTypeByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnumTypesDocument = gql`
    query enumTypes {
  enumTypes {
    ...EnumType
  }
}
    ${EnumTypeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EnumTypesGQL extends Apollo.Query<EnumTypesQuery, EnumTypesQueryVariables> {
    document = EnumTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAllCountryDocument = gql`
    query searchAllCountry($input: SearchCountryInput!) {
  searchAllCountry(data: $input) {
    currentPage
    nextPage
    pageSize
    previousPage
    totalCount
    totalPage
    results {
      ...Country
    }
  }
}
    ${CountryFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAllCountryGQL extends Apollo.Query<SearchAllCountryQuery, SearchAllCountryQueryVariables> {
    document = SearchAllCountryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListCountryDocument = gql`
    query listCountry {
  listCountry {
    ...Country
  }
}
    ${CountryFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListCountryGQL extends Apollo.Query<ListCountryQuery, ListCountryQueryVariables> {
    document = ListCountryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCountryDocument = gql`
    mutation createCountry($input: CreateCountryInput!) {
  createCountry(data: $input) {
    ...Country
  }
}
    ${CountryFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCountryGQL extends Apollo.Mutation<CreateCountryMutation, CreateCountryMutationVariables> {
    document = CreateCountryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCountryDocument = gql`
    mutation updateCountry($input: UpdateCountryInput!) {
  updateCountry(data: $input) {
    ...Country
  }
}
    ${CountryFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCountryGQL extends Apollo.Mutation<UpdateCountryMutation, UpdateCountryMutationVariables> {
    document = UpdateCountryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCountryDocument = gql`
    mutation deleteCountry($id: String!) {
  deleteCountry(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCountryGQL extends Apollo.Mutation<DeleteCountryMutation, DeleteCountryMutationVariables> {
    document = DeleteCountryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDashboardGeneralDocument = gql`
    query getDashboardGeneral($data: SearchDashboardGeneralInput!) {
  getDashboardGeneral(data: $data) {
    general {
      percentage
      year
    }
    satisfactionByUnity {
      year
      units {
        percentage
        unity
        unityId
      }
    }
    benefits {
      name
      units {
        unityId
        unity
        years {
          percentage
          year
          notApplicable
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDashboardGeneralGQL extends Apollo.Query<GetDashboardGeneralQuery, GetDashboardGeneralQueryVariables> {
    document = GetDashboardGeneralDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListBenefitOptionsDocument = gql`
    query listBenefitOptions($data: SearchBenefitOptionsInput!) {
  listBenefitOptions(data: $data) {
    items {
      label
      key
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListBenefitOptionsGQL extends Apollo.Query<ListBenefitOptionsQuery, ListBenefitOptionsQueryVariables> {
    document = ListBenefitOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDashboardBenefitDocument = gql`
    query getDashboardBenefit($data: SearchDashboardBenefitInput!) {
  getDashboardBenefit(data: $data) {
    general {
      year
      percentage
    }
    satisfactionByUnity {
      year
      units {
        percentage
        unity
        unityId
      }
    }
    questions {
      title
      years {
        year
        breakdown {
          bomCount
          bomPct
          naCount
          otimoCount
          otimoPct
          regularCount
          regularPct
          ruimCount
          ruimPct
          totalAnswers
          totalJustifications
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDashboardBenefitGQL extends Apollo.Query<GetDashboardBenefitQuery, GetDashboardBenefitQueryVariables> {
    document = GetDashboardBenefitDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ValidFormQuestionDocument = gql`
    query validFormQuestion($input: String!) {
  validFormQuestion(code: $input) {
    ...FormWeb
  }
}
    ${FormWebFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ValidFormQuestionGQL extends Apollo.Query<ValidFormQuestionQuery, ValidFormQuestionQueryVariables> {
    document = ValidFormQuestionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FormListDashboardDocument = gql`
    query formListDashboard($input: SearchListFormDashboardInput!) {
  formListDashboard(data: $input) {
    assignments {
      assignmentName
      count
    }
    daily {
      count
      date
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FormListDashboardGQL extends Apollo.Query<FormListDashboardQuery, FormListDashboardQueryVariables> {
    document = FormListDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CanEditFormDocument = gql`
    query canEditForm($input: String!) {
  canEditForm(formId: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CanEditFormGQL extends Apollo.Query<CanEditFormQuery, CanEditFormQueryVariables> {
    document = CanEditFormDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FormByIdDocument = gql`
    query formById($input: String!) {
  formById(id: $input) {
    ...FormWeb
  }
}
    ${FormWebFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FormByIdGQL extends Apollo.Query<FormByIdQuery, FormByIdQueryVariables> {
    document = FormByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllMedicalAssistanceDocument = gql`
    query allMedicalAssistance {
  allMedicalAssistance {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllMedicalAssistanceGQL extends Apollo.Query<AllMedicalAssistanceQuery, AllMedicalAssistanceQueryVariables> {
    document = AllMedicalAssistanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubmitFormResponseDocument = gql`
    mutation submitFormResponse($input: SubmitFormResponseInput!) {
  submitFormResponse(data: $input) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SubmitFormResponseGQL extends Apollo.Mutation<SubmitFormResponseMutation, SubmitFormResponseMutationVariables> {
    document = SubmitFormResponseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchFormsDocument = gql`
    query searchForms($input: SearchFormInput!) {
  searchForms(data: $input) {
    currentPage
    nextPage
    pageSize
    previousPage
    totalCount
    totalPage
    results {
      ...SearchFormListDto
    }
  }
}
    ${SearchFormListDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchFormsGQL extends Apollo.Query<SearchFormsQuery, SearchFormsQueryVariables> {
    document = SearchFormsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFormStructureDetailDocument = gql`
    query getFormStructureDetail($id: String!, $input: FormStructureFilterInput!) {
  getFormStructureDetail(formId: $id, data: $input) {
    ...FormStructureDetailDto
  }
}
    ${FormStructureDetailDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFormStructureDetailGQL extends Apollo.Query<GetFormStructureDetailQuery, GetFormStructureDetailQueryVariables> {
    document = GetFormStructureDetailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetJustificationsByQuestionIdDocument = gql`
    query getJustificationsByQuestionId($questionId: String!) {
  getJustificationsByQuestionId(questionId: $questionId) {
    questionId
    questionTitle
    optionId
    valueClassification
    optionText
    justifications {
      justificationText
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetJustificationsByQuestionIdGQL extends Apollo.Query<GetJustificationsByQuestionIdQuery, GetJustificationsByQuestionIdQueryVariables> {
    document = GetJustificationsByQuestionIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FormDetailDashboardDocument = gql`
    query formDetailDashboard($data: SearchDetailDashboardInput!) {
  formDetailDashboard(data: $data) {
    todayCount
    assignments {
      assignmentName
      count
    }
    daily {
      count
      date
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FormDetailDashboardGQL extends Apollo.Query<FormDetailDashboardQuery, FormDetailDashboardQueryVariables> {
    document = FormDetailDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateFormDocument = gql`
    mutation createForm($input: CreateFormInput!) {
  createForm(data: $input) {
    ...Form
  }
}
    ${FormFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateFormGQL extends Apollo.Mutation<CreateFormMutation, CreateFormMutationVariables> {
    document = CreateFormDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFormDocument = gql`
    mutation updateForm($input: UpdateFormInput!) {
  updateForm(data: $input) {
    ...Form
  }
}
    ${FormFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFormGQL extends Apollo.Mutation<UpdateFormMutation, UpdateFormMutationVariables> {
    document = UpdateFormDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteFormDocument = gql`
    mutation deleteForm($id: String!) {
  deleteForm(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteFormGQL extends Apollo.Mutation<DeleteFormMutation, DeleteFormMutationVariables> {
    document = DeleteFormDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadFormDashboardDocument = gql`
    mutation loadFormDashboard($formId: String!) {
  loadFormDashboard(formId: $formId) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadFormDashboardGQL extends Apollo.Mutation<LoadFormDashboardMutation, LoadFormDashboardMutationVariables> {
    document = LoadFormDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateStatusAndPeriodDocument = gql`
    mutation updateStatusAndPeriod($data: UpdateStatusAndPeriodInput!) {
  updateStatusAndPeriod(data: $data) {
    ...FormWeb
  }
}
    ${FormWebFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateStatusAndPeriodGQL extends Apollo.Mutation<UpdateStatusAndPeriodMutation, UpdateStatusAndPeriodMutationVariables> {
    document = UpdateStatusAndPeriodDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAllUnityDocument = gql`
    query searchAllUnity($input: SearchUnityInput!) {
  searchAllUnity(data: $input) {
    currentPage
    nextPage
    pageSize
    previousPage
    totalCount
    totalPage
    results {
      ...Unity
    }
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAllUnityGQL extends Apollo.Query<SearchAllUnityQuery, SearchAllUnityQueryVariables> {
    document = SearchAllUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnityByCountryIdDocument = gql`
    query unityByCountryId($countryId: String!) {
  unityByCountryId(countryId: $countryId) {
    ...Unity
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UnityByCountryIdGQL extends Apollo.Query<UnityByCountryIdQuery, UnityByCountryIdQueryVariables> {
    document = UnityByCountryIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnityByCountryIdsDocument = gql`
    query unityByCountryIds($countryIds: [String!]!) {
  unityByCountryIds(countryIds: $countryIds) {
    id
    name
    status
    country {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnityByCountryIdsGQL extends Apollo.Query<UnityByCountryIdsQuery, UnityByCountryIdsQueryVariables> {
    document = UnityByCountryIdsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUnityDocument = gql`
    mutation createUnity($input: CreateUnityInput!) {
  createUnity(data: $input) {
    ...Unity
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUnityGQL extends Apollo.Mutation<CreateUnityMutation, CreateUnityMutationVariables> {
    document = CreateUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUnityDocument = gql`
    mutation updateUnity($input: UpdateUnityInput!) {
  updateUnity(data: $input) {
    ...Unity
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUnityGQL extends Apollo.Mutation<UpdateUnityMutation, UpdateUnityMutationVariables> {
    document = UpdateUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUnityDocument = gql`
    mutation deleteUnity($id: String!) {
  deleteUnity(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUnityGQL extends Apollo.Mutation<DeleteUnityMutation, DeleteUnityMutationVariables> {
    document = DeleteUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginDocument = gql`
    mutation login($data: AuthInput!) {
  login(data: $data) {
    ...AuthType
  }
}
    ${AuthTypeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginGQL extends Apollo.Mutation<LoginMutation, LoginMutationVariables> {
    document = LoginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentUserDocument = gql`
    query currentUser {
  currentUser {
    ...User
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentUserGQL extends Apollo.Query<CurrentUserQuery, CurrentUserQueryVariables> {
    document = CurrentUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAllUserDocument = gql`
    query searchAllUser($data: SearchUserInput!) {
  searchAllUser(data: $data) {
    currentPage
    nextPage
    pageSize
    previousPage
    totalCount
    totalPage
    results {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAllUserGQL extends Apollo.Query<SearchAllUserQuery, SearchAllUserQueryVariables> {
    document = SearchAllUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserDocument = gql`
    mutation createUser($data: CreateUserInput!) {
  createUser(data: $data) {
    ...User
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserGQL extends Apollo.Mutation<CreateUserMutation, CreateUserMutationVariables> {
    document = CreateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserDocument = gql`
    mutation updateUser($data: UpdateUserInput!) {
  updateUser(data: $data) {
    ...User
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserGQL extends Apollo.Mutation<UpdateUserMutation, UpdateUserMutationVariables> {
    document = UpdateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUserDocument = gql`
    mutation deleteUser($id: String!) {
  deleteUser(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUserGQL extends Apollo.Mutation<DeleteUserMutation, DeleteUserMutationVariables> {
    document = DeleteUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }